/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/_build/webpack_bundles/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 765);
/******/ })
/************************************************************************/
/******/ ({

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// A little Backbone view for displaying a copy invitation warning before allowing the copy of the invitation. Setup
// the page  with an anchor tag. The anchor tag should have a proper href with the copy invitation URL. This View will
// intercept that click, stop it, and then use the HREF for forwarding if the user chooses to continue. This way we
// do not need to know the copy URL in the view nor do we have to break functionality if for some reason we have a
// browser experiencing JavaScript issues.
var CopyInvitation = function (_Backbone$View) {
    _inherits(CopyInvitation, _Backbone$View);

    function CopyInvitation() {
        _classCallCheck(this, CopyInvitation);

        return _possibleConstructorReturn(this, (CopyInvitation.__proto__ || Object.getPrototypeOf(CopyInvitation)).apply(this, arguments));
    }

    _createClass(CopyInvitation, [{
        key: 'copy_invitation',
        value: function copy_invitation(e) {
            e.preventDefault();
            e.stopPropagation();

            var response_callback = function response_callback(response, dialog) {
                if (response.target.innerHTML === 'Copy') {
                    window.location = e.target.href;
                } else {
                    dialog.close();
                }
            };
            var body = 'Are you sure you want to make a copy of this invitation? ' + 'Clicking copy will create a duplicate of this invitation and add it to your Upcoming Events.';
            var dialog = new PopupModal({
                buttons: ['Cancel', 'Copy'],
                body: body,
                title: "Copy Invitation",
                onResponse: function onResponse(response) {
                    return response_callback(response, dialog);
                }
            });
            dialog.show();
        }
    }, {
        key: 'events',
        get: function get() {
            return {
                'click': 'copy_invitation'
            };
        }
    }]);

    return CopyInvitation;
}(Backbone.View);

;

window.CopyInvitation = CopyInvitation;

/***/ }),

/***/ 765:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(236);


/***/ })

/******/ });


// WEBPACK FOOTER //
// view_invitation.includes.event-view-js.event-view-past.js